import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { DashedButton } from 'page/ProfileScreen/basic/DashedButton'
import { SectionTitle } from 'page/ProfileScreen/basic/SectionTitle'
import { me } from 'store/me'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { ProfileButton } from './ProfileButton'

const TITLE = false

export const ProfileSelect = observer(({ inline }: { inline?: boolean }) => {
  const data = !me.external && !opt.stand
  const canAdd_ = inline || store.identities.profiles.every(it => !!it.identity_id)
  const canAdd = canAdd_ && store.identities.profiles.length < 5

  const onData = useLatestCallback(async () => {
    store.profile.step = 'data'
  })

  return (
    <Vertical pad={[1, 0]} gap={16}>
      {TITLE && !inline && (
        <Space gap={12} opposite>
          <SectionTitle>
            {i18n('profile.Profiles')}
          </SectionTitle>
          {data && <DashedButton onClick={onData}>
            {i18n('UserDataManagement')}
          </DashedButton>}
        </Space>
      )}
      <Space gap={12} wrap wide center={inline}>
        {store.identities.profiles.map((it) => (
          !inline || it.identity_id ? <ProfileButton key={it.key} it={it} inline={inline} /> : null
        ))}
        {canAdd && <ProfileButton it={undefined} inline={inline} />}
      </Space>
    </Vertical>
  )
})
